import { PRIVACY_POLICY_URL } from '@schooly/constants';
import { useEffect } from 'react';

/** @deprecated Legacy route — kept for backward compatibility. Redirects to landing privacy policy. */
const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    window.location.replace(PRIVACY_POLICY_URL);
  }, []);

  return null;
};

export default PrivacyPolicy;
